import { luaScript } from '../../helpers/helper_store';

const state = {
	processes: null,
	services: null
};
const mutations = {
	setProcesses: (state, data) => (state.processes = Array.isArray(data) ? data : [ data ]),
	setServices: (state, data) =>  (state.services = Array.isArray(data) ? data : [ data ]),
};

const actions = {
	getProcesses({ rootState, commit }, serverId) {
		return new Promise((resolve, reject) => {
			luaScript('ps2', 'run', { serverID: serverId }, rootState.login)
				.then((result) => {
					commit('setProcesses', result.tty);
					resolve();
				})
				.catch(() => {
					commit('setProcesses', []);
					reject();
				});
		});
	},
	stopTtyProcess({ rootState, dispatch }, { serverID, pid }) {
		return new Promise((resolve, reject) => {
			luaScript('ps2kill', 'run', { serverID, pid }, rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getServices({ rootState, commit }, idServer) {
		return new Promise((resolve, reject) => {
			luaScript('workService', 'getService', { idServer }, rootState.login)
				.then((result) => {
					commit('setServices', result);
					resolve();
				})
				.catch(() => {
					commit('setServices', []);
					reject();
				});
		});
	},
	actionWithService({ rootState, commit }, { idServer, method, services }) {
		return new Promise((resolve, reject) => {
			luaScript('workService', 'runService', { idServer, method, services }, rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	}
};

const getters = {
	getProcessesArray: (state) => state.processes,
	getServices: (state) => state.services
};

export default {
	state,
	mutations,
	actions,
	getters
};
